import { useEffect, useRef } from 'react';
import EditComponent from './MembershipRechargeLockRulesEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { Switch, Tooltip } from 'antd';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';

const WebComponent = (props: any) => {

    const ref = useRef<any>(undefined);
    useEffect(() => {

    }, []);

    //表头
    const columnsHead = [
        {
            title: '规则',
            dataIndex: 'ruleName',
            render: (text: any) =>
                <Tooltip placement="topLeft" title={text}>{
                    text?.length >= 8 ? text?.substring(0, 8) + '......' : text
                }</Tooltip>
        },
        {
            title: '余额锁定',
            dataIndex: 'isBalanceLock',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '余额计算模式',
            dataIndex: 'balanceCalcMode',
            render: (text: any) => text?.name
        },
        {
            title: '赠送锁定',
            dataIndex: 'isGiftsLock',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '赠送计算模式',
            dataIndex: 'giftsCalcMode',
            render: (text: any) => text?.name
        },
        {
            title: '积分锁定',
            dataIndex: 'isPointsLock',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '积分计算模式',
            dataIndex: 'pointsCalcMode',
            render: (text: any) => text?.name
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    const extendProps: WebUniversalProps = {
        ...props,
        titleName: '会员充值锁定规则',
        apiId: 'membershipRechargeLockRules',
        columns,
        editOptions: {
            Editor: EditComponent
        },
        serviceId: 'business'
    };

    return (<WebUniversal {...extendProps} ref={ref} />)
}

export default WebComponent;
